import { createSelector } from "reselect";
import get from "lodash.get";
import {
  hasAllowEditOtherUsersWorkPermissionSelector,
  hasReopenWoundRevisionsPermissionSelector
} from "src/selectors/ui_config_selectors/patients";
import { assessmentAnswersResourceSelectors } from "src/selectors/data_selectors";
import { currentUserSelector } from "src/selectors/config_selectors/current_user_selector";

export function createReopenIsDisabledSelector({ assessmentAnswer, revision }) {
  return createSelector(
    hasAllowEditOtherUsersWorkPermissionSelector,
    hasReopenWoundRevisionsPermissionSelector,
    assessmentAnswersResourceSelectors.deleteLoadStateWithStatusByIdSelector,
    currentUserSelector,
    (
      canEditOtherUsersWork,
      canReopenWoundRevision,
      deleteLoadStateWithStatusById,
      currentUser
    ) => {
      const revisionAuthorId = get(revision, "attributes.userId", null);
      const isRevisionAuthor =
        revisionAuthorId && revisionAuthorId === currentUser.id;

      return (
        (!canEditOtherUsersWork && !isRevisionAuthor) ||
        !canReopenWoundRevision ||
        deleteLoadStateWithStatusById[assessmentAnswer.id] === "loading" ||
        deleteLoadStateWithStatusById[assessmentAnswer.id] === "loaded"
      );
    }
  );
}
